import React from 'react';
import type { WorkflowEdgeProps } from 'flow/service/graph';
import BaseEdge from '../BaseEdge';


function PreviewEdge(props: WorkflowEdgeProps) {
  return (
    <BaseEdge
      {...props}
      style={{
        stroke: 'var(--cl-gray-300)',
      }}
    />
  );
}

export default React.memo(PreviewEdge);
